/* tslint:disable */
import { SettingVtk } from './setting-vtk';

/**
 */
export class ParamSettingVtk {
    setting_vtk?: SettingVtk;
    default?: number;
}
